<template>
  <div class="row">
    <div class="col-md-12">
      <div class="box box-primary">
        <div class="box-header with-border">
          <h3 class="box-title">
            {{ $t('menu.dashboard') }}
          </h3>
        </div>
        <div class="box-body">
          <h3>{{ $t('string.welcomeTo') }} {{ config.VUE_APP_NAME }}</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
  metaInfo () {
    return {
      title: this.$t('string.dashboard'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  data () {
    return {
      config: process.env
    }
  },
  mounted () {
    this.onResizeWindow()
  }
}
</script>
